export default __webpack_public_path__ + "static/media/regular-florale.11c93d75.jpg";